import * as React from 'react';

/**
 * React hook for managing the "busy" state of a component.
 * If one or more of the provided promises is pending, this hook will return true.
 *
 * @param {Promise<any>[]} promises
 * @returns {boolean}
 */
export default function useIsBusy(promises: Promise<any>[]): boolean {
    const [busy, setBusy] = React.useState(true);

    React.useEffect(() => {
        setBusy(!!promises.length);

        Promise.all(promises)
            .finally(() => {
                setBusy(false);
            });
    }, promises);

    return busy;
}
